import { createStyles, makeStyles } from '@material-ui/core';
import { Sizes } from '../../../../../styles/sizes';
import { colorVariables } from '../../../../../styles/colorVariables';

export const useStyles = makeStyles((theme) =>
  createStyles({
    modalBox: {
      position: 'absolute',
      width: 880,
      top: 40,
      padding: '40px 30px 30px 30px',
      overflow: 'hidden',
      [theme.breakpoints.down(Sizes.desktop)]: {
        minWidth: 'auto',
        width: '90vw',
        top: 30,
        bottom: 60,
        padding: '25px 0',
      },
    },
    modalContent: {
      overflow: 'hidden',
      maxWidth: '95vw',
      [theme.breakpoints.down(Sizes.desktop)]: {
        maxWidth: '95vw',
      },
    },
    formWrapper: {
      height: '67vh',
      overflowY: 'auto',
      paddingRight: 5,
    },
    title: {
      fontSize: '24px',
      fontWeight: 700,
      color: colorVariables.userNavy
    },
    section1: {
      marginTop: 20,
      paddingBottom: 10,
      marginBottom: 10,
    },
    section2: {
      paddingBottom: 10,
      marginBottom: 10,
    },
    defaultRule: {
      marginTop: 10,
    },
    ahalf: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 20,
    },
    ahalfCol: {
      width: '50%',
      display: 'inline-block',
    },
    label: {
      fontSize: 12,
      fontWeight: 400,
      color: colorVariables.grey80,
      marginTop: 10,
    },
    dropdown: {
      paddingTop: 10,
    },
    bottomLine: {
      borderBottom: '1px solid #E0E6ED',
    },
    sectionTitle: {
      fontSize: 12,
      fontWeight: 700,
      color: '#8796AA',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      marginBottom: 5,
    },
    sectionDescription: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '22px',
      color: '#5B6578'
    },
    customText: {
      color: '#8796AA',
      fontSize: 12,
      fontWeight: 700,
      textTransform: 'uppercase',
    },
    infoBox: {
      marginTop: 20,
    },
    helpInfo: {
      color: '#5B6578',
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '16px',
      marginTop: 5,
    },
    buttonContainer: {
      marginTop: 20,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    schedulesBox: {
      marginTop: 10,
      '& > div': {
        marginRight: 8,
        background: 'rgba(207, 215, 230, 0.5)',
        borderRadius: 14,
        fontSize: 12,
        fontWeight: 700,
        color: colorVariables.grey80,
        marginBottom: 10,
      },
      '& > div:focus': {
        background: 'rgba(207, 215, 230, 0.5)',
      },
      '& .chipSelected': {
        border: '1px solid #51D9B0',
        backgroundColor: '#E4FCF5',
        color: colorVariables.navy,
      },
      '& .chipSelected:focus': {
        backgroundColor: '#E4FCF5',
      },
    },
    deleteIcon: {
      color: colorVariables.grey60,
      width: 16,
      height: 16,
      '&:hover': {
        color: '#51D9B0',
      },
    },
    scheduleChip: {
      '&:hover': {
        backgroundColor: '#E4FCF5',
      },
    },
    customDayInfo: {
      color: colorVariables.grey80,
      fontSize: 14,
      fontWeight: 400,
      marginBottom: 20,
    },
    cutoffTime: {
      paddingTop: 10,
      '& div': {
        width: '100%'
      }
    }
  }),
);
